/**
 * This directive replaces the html code
    -------------------------
      <button class="btn" ng-click="cancel()">Cancel</button>

      <button class="btn btn-success" ng-click="updateUser()" ng-disabled="saving" ng-show="isUpdate">
      <i ng-show="saving" class="fa fa-spinner fa-spin" style="min-width: 50px"></i> {{saving?"":"Update"|translate}}
      </button>

      <button class="btn btn-success" ng-click="createUser()" ng-disabled="saving" ng-show="isNew"
      <i ng-show="saving" class="fa fa-spinner fa-spin" style="min-width: 50px"></i>{{saving?"":"Create"|translate}}
      </button>
   ------------------------

   These code are most of the modals, for now the directive is just in the user.html, because its need a slight change in the controllers
   for the function

 */
angular.module('qkr').directive('saveButton', ['gettextCatalog', function(gettextCatalog) {
    return {

        restrict: 'EA',
        scope: {

            cancelFunction: '&',
            callFunction: '&',
            saving: '=',
            isNew: '='
        },
        template: require('../directives/modal.save.button.html'),
        link(scope, element, attrs) {
            scope.textCancelBtn = gettextCatalog.getString('Cancel');

            // If it passed a customised attrs text, it's update
            if (attrs.textCancelBtn) {
                scope.textCancelBtn = attrs.textCancelBtn;
            }

            scope.setBtnText = function() {
                if (scope.isNew) {
                    // If it passed a customised attrs text, it's update
                    if (attrs.textNew) {
                        scope.textBtn = attrs.textNew;
                    } else {
                        scope.textBtn = gettextCatalog.getString('Create');
                    }
                } else if (attrs.textUpdate) {
                        scope.textBtn = attrs.textUpdate;
                    } else {
                        scope.textBtn = gettextCatalog.getString('Update');
                    }
            };

            scope.$watch('saving', (newVal, oldVal) => {
                // If isNew and newVal == true because its saving
                if (newVal) {
                    scope.textBtn = '';
                } else {
                    scope.setBtnText();
                }
            });
        }
    };
}]);



// WEBPACK FOOTER //
// ./src/directives/modal.save.button.directive.js